import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { OrganizationType } from "@tfg/types/types/organization.types"

import { DataFetchWrapper } from "~/components/DataFetchWrapper"
import { CommunicationStudio } from "~/pages/Brand/CommunicationStudio"
import { useGetOrganizationSettingsQuery } from "~/pages/Brand/CommunicationStudio/OrganizationGeneralSettings/hooks/useGetOrganizationSettingsQuery"
import { OrganizationSettingsProvider } from "~/pages/Brand/CommunicationStudio/contexts/organizationSettings/OrganizationSettingsContext"
import { OrganizationSubscriptionPlanPermissionsProvider } from "~/pages/Brand/CommunicationStudio/contexts/organizationSubscriptionPlanPermissions/OrganizationSubscriptionPlanPermissionsContext"
import { useAuth } from "~/store/auth-context.tsx"

export const CommunicationStudioLoader = () => {
  const { user, homeRedirectUrl } = useAuth()
  const navigate = useNavigate()
  const query = useGetOrganizationSettingsQuery(user?.organization?.id)

  useEffect(() => {
    if (
      user?.organization.type !== OrganizationType.BRAND &&
      user?.organization.type !== OrganizationType.PLATFORM_ADMIN
    ) {
      navigate(homeRedirectUrl)
    }
  }, [navigate, user?.organization, homeRedirectUrl])

  return (
    <DataFetchWrapper query={query}>
      {({ data: organization }) => (
        <OrganizationSettingsProvider organization={organization}>
          <OrganizationSubscriptionPlanPermissionsProvider
            initialSubscriptionPlan={organization.settings.subscriptionPlan}
          >
            <CommunicationStudio />
          </OrganizationSubscriptionPlanPermissionsProvider>
        </OrganizationSettingsProvider>
      )}
    </DataFetchWrapper>
  )
}
